import { supabase } from '@/integrations/supabase/client';

export async function approvePolicy(policyId: string, approvedBy: string): Promise<void> {
  // Get the latest version with its details
  const { data: latestVersion, error: fetchError } = await supabase
    .from('policy_versions')
    .select('id, is_substantive, calculated_next_review, review_cadence_months')
    .eq('policy_id', policyId)
    .order('version_number', { ascending: false })
    .limit(1)
    .single();

  if (fetchError || !latestVersion) {
    throw new Error('Failed to fetch latest version');
  }

  // Single atomic RPC call — version update, policy update, and audit log
  const { error } = await supabase.rpc('approve_policy_version', {
    p_version_id: latestVersion.id,
    p_approved_by: approvedBy,
    p_is_substantive: latestVersion.is_substantive,
    p_calculated_next_review: latestVersion.calculated_next_review ?? null,
    p_review_cadence_months: latestVersion.review_cadence_months ?? null,
  });

  if (error) throw new Error(error.message);
}
